module.exports = __webpack_public_path__ + "static/media/Estampa_VirgenCoromoto.af500bd4.jpg";